const envSource = window._ENV_ ?? import.meta.env; // if runtime env vars are present, use those or fallback to build

export const appConfig = {
  apiUrl: envSource.VITE_API_URL,
  kcAuthority: envSource.VITE_KC_AUTHORITY,
  kcRedirectUri: envSource.VITE_KC_REDIRECT,
  documentTitle: envSource.VITE_DOCUMENT_TITLE,
  accountsUrl: envSource.VITE_ACCOUNTS_URL,
  tourVersion: envSource.VITE_TOUR_VERSION ?? '3.11',
  tourDatasetId: envSource.VITE_TOUR_DATASET_ID ?? '16823',
  isDatasetComparisonEnabled: envSource.VITE_ENABLE_DATASET_COMPARISON === 'true',
};
